import { browser } from '@openclassrooms/utils';

export default function isOnPage(pageName) {
  const regexp = new RegExp(`^/([a-zA-Z]{2}-)?[a-zA-Z]{2}${pageName}`);
  return Boolean(browser.document.location.pathname.match(regexp));
}
